import { map, compose, find, propEq } from "ramda"

export const setNodeRolePolicyMap = (state, action) => {
  const { nodeRolePolicyMap } = action
  return { ...state, nodeRolePolicyMap }
}

export const updateNodeRolePolicyMap = (state, action) => {
  const { nodeRoleId, policyId, policyName } = action
  const { nodeRolePolicyMap } = state

  const list = compose(
    hasObj =>
      hasObj
        ? update(nodeRolePolicyMap, nodeRoleId, policyId, policyName)
        : [...nodeRolePolicyMap, { nodeRoleId, policyId, policyName }],
    list => hasObj(list, nodeRoleId),
  )(nodeRolePolicyMap)

  return { ...state, nodeRolePolicyMap: list }
}

const hasObj = (list, nodeRoleId) => {
  return find(propEq("nodeRoleId", nodeRoleId), list)
}

const update = (list, nodeRoleId, policyId, policyName) => {
  return map(p => {
    if (p.nodeRoleId === nodeRoleId) {
      return {
        ...p,
        policyId,
        policyName,
      }
    }
    return p
  }, list)
}
